import React from "react";
import { Grid, Typography } from "@mui/material";
import logo from "./../../../assets/images/logo.svg";

function Header() {
	return (
		<>
			<Grid
				container
				spacing={0}
				// direction="row"
				alignItems="center"
				justifyContent="center"
				mt={3}
			>
				<Grid item xs={12} lg={12} xl={12} sx={{ m: 1 }}>
					<img src={logo} alt="Logo" style={{ width: "200px", height: "auto" }} />
				</Grid>
			</Grid>
			<Grid container spacing={0} alignItems="center" justifyContent="center" mt={4}>
				<Grid
					item
					xs={12}
					lg={12}
					xl={12}
					sx={{ m: 1 }}
					style={{ justifyContent: "flex-start" }}
				>
					<Typography variant="h5" component="h5" ml={0}>
						Apply as a Shadchan
					</Typography>
				</Grid>
				<Typography
					variant="h6"
					component="h6"
					ml={1}
					sx={{ fontSize: 14, display: "flex", justifyContent: "flex-start" }}
				>
					Already have an account?
					<Typography
						onClick={() => (window.location.href = "http://zuug.a-dmin.ai")}
						variant="h6"
						component="h6"
						ml={1}
						sx={{
							fontSize: 14,
							display: "flex",
							justifyContent: "flex-start",
							cursor: "pointer",
							textDecoration: "underline",
						}}
					>
						Sign In
					</Typography>
				</Typography>
			</Grid>
		</>
	);
}

export default Header;
